<template>
  <transition name="slide" mode="out-in">
    <div v-if="Object.keys(item).length" class="mini-cart-notification">
      <span class="mini-cart-notification-title">
        {{ $t('miniCart.productAddedToCart') }}
        <img src="/assets/images/mini_cart_white.svg" alt="cart">
      </span>
      <div class="mini-cart-item">
        <img :src="image" alt="">
        <div class="mini-cart-item-desc">
          <span class="mini-cart-item-desc-brand">{{ brand }}</span>
          <span class="mini-cart-item-desc-name">{{ product.name }}</span>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'mini-cart-notification',

  data () {
    return {
      item: {}
    }
  },

  computed: {
    product () {
      return this.item.entry.product
    },
    image () {
      return this.product?.images?.[0].url
    },
    brand () {
      return this.product?.brands?.[0].name
    }
  },

  mounted () {
    this.$globalEvent.$on('device-added', (payload, type) => {
      let device
      if (type === 'add') {
        device = payload.cartModificationList.cartModifications.find(item => item.entry.productOfferingType === 'DEVICE')
      } else if (type === 'replace') {
        device = payload.cartModifications.find(item => item.entry.productOfferingType === 'DEVICE')
      }
      if (device) {
        this.item = device
      } else {
        this.item = payload.cartModificationList.cartModifications.find(item => item.entry.productOfferingType === 'TARIFF')
      }
      setTimeout(() => {
        this.item = {}
      }, 5000)
    })
  }
}
</script>

<style lang="scss" scoped>
.mini-cart-notification {
  position: fixed;
  top: 8rem;
  right: 2.4rem;
  border-radius: .5rem;
  box-shadow: 0 .3rem .6rem rgba(0, 0, 0, .16);
  min-width: 30rem;
  background: $white;
  color: $text;

  @media (map_get($breakpoints, lg)) {
    right: auto;
    left: -11.3rem;
  }

  @media (map_get($breakpoints, xl)) {
    right: auto;
    left: 3.3rem;
  }
}

.mini-cart-notification-title {
  display: flex;
  justify-content: space-between;
  border-radius: .5rem .5rem 0 0;
  padding: 1.6rem 2.4rem;
  background: linear-gradient(to right, $mtel-red, $alt-red 17%, $mtel-red 51%, $warning);
  color: $white;
  font-size: 2rem;
}

.mini-cart-item {
  display: flex;
  padding: 1.6rem 2.4rem 2.4rem;

  img {
    height: 6rem;
  }
}

.mini-cart-item-desc {
  margin-left: .8rem;
}

.mini-cart-item-desc-brand {
  display: block;
  margin-bottom: .2rem;
  font-size: 1.2rem;
  text-transform: uppercase;
}

.mini-cart-item-desc-name {
  font-weight: 500;
}
</style>
